import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-salesforce-not-authorized',
  templateUrl: './salesforce-not-authorized.component.html',
  styleUrl: './salesforce-not-authorized.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SalesforceNotAuthorizedComponent {}
